import { useEffect, useState } from 'react';
import IconCrossCircleFilled from '@picsart/icons/IconCrossCircleFilled';

import { getUrlWithoutQueryParams } from '../../../../utils/widgets/shareWidget';
import { CopyInfoAlert, Modal } from '../../../core';
import EmbedModal from '../EmbedModal';
import ShareModal from '../ShareModal';

import useStyles from './styles';
import { IBaseShareModal } from './types';

let copyInfoTimeout: ReturnType<typeof setTimeout>;

function BaseShareModal({
  showModal,
  setShowModal,
  toolName,
  analytics,
  redirectUrl,
  widgetUrl,
}: IBaseShareModal) {
  const [showShareModal, setShowShareModal] = useState(true);
  const [showCopyInfoAlert, setShowCopyInfoAlert] = useState(false);
  const [toolUrl, setToolUrl] = useState('');
  const classes = useStyles({ showCopyAlert: showCopyInfoAlert });
  const alert = showCopyInfoAlert ? (
    <CopyInfoAlert
      className={classes.copyTextAlert}
      text="Link copied to clipboard"
      onClose={() => setShowCopyInfoAlert(false)}
    ></CopyInfoAlert>
  ) : null;

  useEffect(() => {
    if (redirectUrl != null) {
      setToolUrl(redirectUrl);
    } else {
      const toolWithoutQueryParams = getUrlWithoutQueryParams(window.location.href);
      setToolUrl(toolWithoutQueryParams);
    }
  }, [redirectUrl]);

  useEffect(() => {
    if (showCopyInfoAlert) {
      clearTimeout(copyInfoTimeout);
      copyInfoTimeout = setTimeout(() => {
        setShowCopyInfoAlert(false);
      }, 3000);
    }
    return () => clearTimeout(copyInfoTimeout);
  }, [showCopyInfoAlert]);

  const handleCloseModal = () => {
    setShowCopyInfoAlert(false);
    setShowShareModal(true);
    setShowModal(false);
  };

  if (!showModal) {
    return null;
  }
  return (
    <>
      <Modal
        onClose={handleCloseModal}
        className={classes.modal}
        backdropClassName={classes.modalRoot}
        alertClassName={classes.copyTextAlertContainer}
        alert={alert}
      >
        <CopyInfoAlert
          className={classes.copyTextAlert}
          text="Link copied to clipboard"
          onClose={() => setShowCopyInfoAlert(false)}
        ></CopyInfoAlert>

        <div onClick={handleCloseModal} className={classes.modalClose}>
          <IconCrossCircleFilled />
        </div>

        {showShareModal ? (
          <ShareModal
            analytics={analytics}
            setShowCopyInfoAlert={setShowCopyInfoAlert}
            setShowShareModal={setShowShareModal}
            toolName={toolName}
            toolUrl={toolUrl}
          ></ShareModal>
        ) : (
          <EmbedModal
            analytics={analytics}
            setShowShareModal={setShowShareModal}
            toolName={toolName}
            toolUrl={toolUrl}
            widgetUrl={widgetUrl}
          ></EmbedModal>
        )}
      </Modal>
    </>
  );
}

export default BaseShareModal;
